import { Component } from 'preact';

export default class Brown extends Component {

    constructor(props) {
        super(props);
    }

    render() {
        return (
            <style dangerouslySetInnerHTML={{
                __html: `
                :root {
                    /* Global */
                    --brand-global-radius: 0;

                    /* Colors */
                    --brand-color-background: #FFF;
                    --brand-color-secondary: #FFF;
                    --brand-color-border: #E1E1E1;
                    --brand-color-body: #1C1C1C;
                    --brand-color-primary: #816B40;
                    --brand-color-focus: #FFCC00;

                    /* Fonts */
                    --brand-font-family-title: "Libre Baskerville", serif;
                    --brand-font-family-body: "Karla";
                    --brand-font-weight-regular: 400;
                    --brand-font-weight-bold: 700;

                    /* Title */
                    --brand-title-weight: 400;
                    --brand-title-transform: none;
                    --brand-title-spacing: 0;

                    /* Input */
                    --brand-input-border-width: 1px;
                    --brand-input-border-color: #1C1C1C;

                    /* Button */
                    --brand-button-radius: 0;
                    --brand-button-border-size: 0px;
                    --brand-button-border-color: transparent;
                    --brand-button-font-color: #FFF;
                    --brand-button-font-size: 14px;
                    --brand-button-font-weight: 700;
                    --brand-button-font-transform: uppercase;
                    --brand-button-font-spacing: 1px;
                  }
            `
            }}></style>

        );
    }
}